import { sendData, getData } from "./../../misc/server.js";
export default {
  state: {
    data: [],
    chapters: [],
    loading: false,
    action_loading: false,
    current_chapter: 1,
    coming_exam: null,
  },
  mutations: {
    SET_SUBJECT(state, payload) {
      state.data = payload;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_CHAPTER(state, payload) {
      state.chapters = payload;
    },
    SET_COMING_EXAM(state, payload) {
      state.coming_exam = payload;
    },
    SET_CURRENT_CHAPTER(state, payload) {
      state.current_chapter = payload;
    },
    SET_ACTION_LOADING(state, payload) {
      state.action_loading = true;
    },
    PUSH_HOMEWORK(state, payload) {
      state.data[0].homeworks.push(payload);
    },
    REMOVE_HOMEWORK(state, payload) {
      state.data[0].homeworks = state.data[0].homeworks.filter((val) => {
        if (val.id != payload) {
          return val;
        }
      });
    },
  },
  actions: {
    async get_subject({ commit }, payload) {
      var url = "subject/get?";
      if (payload.id) {
        url += "id=" + payload.id;
      }

      if (payload.chapter_id) {
        url += "&chapter_id=" + payload.chapter_id;
      } else {
        url += "&chapter_id=1";
      }

      url += "&";

      commit("SET_LOADING", true);
      var response = await getData(url);

      commit("SET_SUBJECT", response.subject);
      commit("SET_CHAPTER", response.chapters);
      commit("SET_CURRENT_CHAPTER", response.current_chapter);
      commit("SET_COMING_EXAM", response.coming_exam);
      commit("SET_LOADING", false);
    },
    async uploadHomeWork({ commit }, payload) {
      var url = "subject/home_work/upload";
      commit("SET_ACTION_LOADING", true);
      var response = await sendData(url, payload);
      if (response.success) {
        commit("SET_SUCCESS", response.message, { root: true });
        commit("PUSH_HOMEWORK", response.data);
      }
      commit("SET_ACTION_LOADING", false);
    },

    async deleteHomeWork({ commit }, payload) {
      var url = "subject/home_work/delete";
      commit("SET_ACTION_LOADING", true);
      var response = await sendData(url, payload);
      if (response.success) {
        commit("SET_SUCCESS", response.message, { root: true });
        commit("REMOVE_HOMEWORK", payload.get("id"));
      }
      commit("SET_ACTION_LOADING", false);
    },
  },
  getters: {
    subjects(state) {
      return state.data;
    },
    subject_loading(state) {
      return state.loading;
    },
    each_subject(state) {
      if (state.data) {
        return state.data;
      }
    },
    chapters(state) {
      return state.chapters;
    },
    current_chapter(state) {
      return state.current_chapter;
    },
    coming_exam(state) {
      return state.coming_exam;
    },
  },
};
